import React from "react";

export const FeaturesTitles = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={57}
            viewBox="0 0 56 57"
            fill="none"
            {...props}
        >
            <path
                d="M19.991 41.35c3.018-.115 4.179-.691 4.179-3.572V16.922c0-.691-.233-.922-1.393-.922-3.83 0-6.268 2.305-6.965 5.992H15l.232-7.605h25.536L41 21.992h-.813C39.492 18.305 37.17 16 33.224 16c-1.16 0-1.393.116-1.393.922v20.971c0 2.881 1.161 3.457 4.179 3.572v.922H19.99V41.35z"
                fill="#32393E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46 9.387H10v38h36v-38zm1-1v40H9v-40h38z"
                fill="#32393E"
            />
            <path
                d="M50 5.387h-7v7h7v-7zM13 5.387H6v7h7v-7zM50 44.387h-7v7h7v-7zM13 44.387H6v7h7v-7z"
                fill="#FE9235"
            />
        </svg>
    )
}
